import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import TopBar from './components/TopBar/TopBar';
import ShowcaseHomePage from './pages/ShowcaseHome';
import AboutPage from './pages/About';
import ContactPage from './pages/Contact';
import LoginPage from './login/LoginPage';
import SignUpPage from './pages/SignUp';
import MarketplacePage from './pages/Marketplace';
import UserProfilePage from './pages/User';
import PurchasedLibraryPage from './pages/PurchasedLibrary';
import CheckoutSuccessPage from './pages/Checkout/CheckoutSuccessPage';
import CheckoutCancelPage from './pages/Checkout/CheckoutCancelPage';
import { CartProvider } from './context/CartContext';

function AppShellLayout() {
  return (
    <div className="app-shell">
      <TopBar />
      <div className="app-shell__content">
        <Outlet />
      </div>
    </div>
  );
}

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<AppShellLayout />}>
            <Route path="/" element={<ShowcaseHomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignUpPage />} />
            <Route path="/marketplace" element={<MarketplacePage />} />
            <Route path="/user" element={<UserProfilePage />} />
            <Route path="/library" element={<PurchasedLibraryPage />} />
            <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
            <Route path="/checkout/cancel" element={<CheckoutCancelPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
